import React from "react";
import Header from "../components/header";
import AuthService from "./../services/auth.service";

export interface iState {
    username: string,
    password: string,
    code: string,
    loading: boolean,
    message: string,
    showCodeUi: boolean,
    validate: boolean
}

class Login extends React.Component<any, iState> {
  private formLogin: React.RefObject<HTMLFormElement>;
  private formCode: React.RefObject<HTMLFormElement>;

  state = {
    username: '',
    password: '',
    code: '',
    loading: false,
    message: '',
    showCodeUi: false,
    validate: false
  }

  constructor(props: any) {
    super(props);
        
    this.formLogin = React.createRef();
    this.formCode = React.createRef();
  }

  componentDidMount() {
    this.afterLogin();
  }

  onChangeCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    const code = e.target.value;
    this.setState({code});
  };

  onChangeUsername = (e: React.ChangeEvent<HTMLInputElement>) => {
    const username = e.target.value;
    this.setState({username});
  };

  onChangePassword = (e: React.ChangeEvent<HTMLInputElement> ) => {
    const password = e.target.value;
    this.setState({password});
  };

  handleCancel = (e: React.FormEvent) => {
    this.setState({message:"", loading:false, showCodeUi: false});
    AuthService.logout();
  };

  handleCodeVerification = (e: React.FormEvent) => {
    e.preventDefault();
    this.setState({message:"", loading:true, validate: true});

    const user = AuthService.getCurrentUser();
    const token = user.token;

   if (this.formLogin != undefined && this.formLogin.current != undefined)
        this.formLogin.current.validateAll();
     {
      AuthService.verifyCode(this.state.username, this.state.code, token).then(
        this.afterLogin,
        this.errorVerifyCode
      );
    }
  };

  handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    this.setState({message: "", loading: true, validate: true});
   if (this.formCode != undefined && this.formCode.current != undefined)
       this.formCode.current.validateAll();
     {
      AuthService.login(this.state.username, this.state.password).then(
        this.afterLogin,
        this.errorLogin
      );
    }
  };

  afterLogin = () => {
    const user = AuthService.getCurrentUser();

    if (user.accessToken) {
      if (user.forceChangePassword === "1")
        this.props.history.push("/changepassword");
      else
        this.props.history.push("/search");
    } else if (user.token){
      this.setState({showCodeUi: true, validate: false, code: "", password: ""});
    }

    this.setState({message: "", loading: false});
  }

  errorLogin = (error: any) => {
    if ((error.response && error.response.data && error.response.data.message) || error.message || error.toString())
      this.setState({message: 'Invalid email or password', loading:false});
  }

  errorVerifyCode = (error: any) => {
    if ((error.response && error.response.data && error.response.data.message) || error.message || error.toString())
      this.setState({message: 'Unable to verify code', loading:false});
  }

  public render() {
    return (
      <>
        <Header></Header>
          <div className="row mt-5 justify-content-md-center">
            <div className="col-sm-12 col-md-6 col-lg-4">
              {this.state.message && (
                <div className="form-group">
                  <div className="text-danger">
                    {this.state.message}
                  </div>
                </div>
              )}
            </div>
        </div>
        <div className="row mt-2 justify-content-md-center">
            <div className="col-sm-12 col-md-6 col-lg-4">
            { this.state.showCodeUi === false &&
              <form onSubmit={this.handleLogin} ref={this.formLogin} className={`needs-validation ${this.state.validate ? 'was-validated': ''}`}>
                <div className="form-group">
                  <label className="form-label fw-bold" htmlFor="username">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="username"
                    value={this.state.username}
                    onChange={this.onChangeUsername}
                    required={true}
                  />
                  <div className="invalid-feedback">
                    Please enter a valid email address
                  </div>
                </div>
                <div className="form-group mt-2">
                  <label className="form-label fw-bold" htmlFor="password">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    value={this.state.password}
                    onChange={this.onChangePassword}
                    required={true}
                  />
                  <div className="invalid-feedback">
                    Please enter password
                  </div>
                </div>
                <div className="form-group mt-4">
                  <button className="btn btn-primary btn-block" disabled={this.state.loading}>
                    {this.state.loading && (
                      <><span className="spinner-border spinner-border-sm"></span>&nbsp;</>
                    )}
                    <span>Login</span>
                  </button>
                </div>
              </form>
            }
            { this.state.showCodeUi === true &&
              <form onSubmit={this.handleCodeVerification} ref={this.formCode}>
                <div className="form-group">
                  <label className="form-label fw-bold" htmlFor="username">Code</label>
                  <input
                    type="text"
                    className="form-control"
                    name="username"
                    value={this.state.code}
                    onChange={this.onChangeCode}
                    required={true}
                  />
                  <div className="invalid-feedback">
                    Please enter code sent to you.
                  </div>
                </div>
                <div className="form-group mt-4">
                  <button className="btn btn-primary" disabled={this.state.loading}>
                    {this.state.loading && (
                      <><span className="spinner-border spinner-border-sm"></span>&nbsp;</>
                    )}
                    <span>Submit</span>
                  </button>
                  <button className="btn btn-outline-warning float-end"
                    type="button"
                    disabled={this.state.loading}
                    onClick={this.handleCancel}>Cancel</button>
                </div>
              </form>
            }
            </div>
          </div>
      </>
    );
  }
}

export default Login;